import svgArrowReverse from '@img/shapes/arrow-mask-reverse.svg?url';
import svgArrow from '@img/shapes/arrow-mask.svg?url';
import svgHexagonSquash from '@img/shapes/hexagon-solid-squash.svg?url';
import svgHexagon from '@img/shapes/hexagon-solid.svg?url';
import svgHexagonOpenTop from '@img/shapes/team-member-card/hexagon-open-top.svg?url';
import * as React from 'react';
import S from './ImageMask.styles';
const ImageMask = ({ children, mask, ...rest }) => {
    if (!mask) {
        return React.createElement(React.Fragment, null, children);
    }
    const maskStyles = { '--mask': `url('${getMaskUrl(mask)}')` };
    return (React.createElement(S.Container, { ...rest, style: maskStyles }, children));
    function getMaskUrl(mask) {
        switch (mask) {
            case 'hexagon':
                return svgHexagon;
            case 'hexagon-open-top':
                return svgHexagonOpenTop;
            case 'hexagon-squash':
                return svgHexagonSquash;
            case 'arrow':
                return svgArrow;
            case 'arrow-reverse':
                return svgArrowReverse;
            default:
                return '';
        }
    }
};
export default ImageMask;
